import React, { useState } from 'react';
import { Tooltip, useTheme } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { StyledMapButton, iconStyle } from './materialTheme/StyledMapComponents';
import 'leaflet/dist/leaflet.css';

const LockMapButton = ({ map, onLockToggle }) => {
  const [isLocked, setIsLocked] = useState(false);
  const theme = useTheme();

  const toggleLock = () => {
    if (isLocked) {
      map.dragging.enable();
      map.touchZoom.enable();
      map.doubleClickZoom.enable();
      map.scrollWheelZoom.enable();
      map.boxZoom.enable();
      map.keyboard.enable();
    } else {
      map.dragging.disable();
      map.touchZoom.disable();
      map.doubleClickZoom.disable();
      map.scrollWheelZoom.disable();
      map.boxZoom.disable();
      map.keyboard.disable();
    }
    setIsLocked(!isLocked);
    if (onLockToggle) {
      onLockToggle(!isLocked);
    }
  };

  return (
    <Tooltip title={isLocked ? 'Unlock the view' : 'Lock the view'}>
      <StyledMapButton
        variant="contained"
        color="primary"
        className={`lock-map-button ${isLocked ? 'active' : ''}`}
        startIcon={
          isLocked ? (
            <LockIcon sx={iconStyle({ theme, isActive: isLocked })} />
          ) : (
            <LockOpenIcon sx={iconStyle({ theme, isActive: isLocked })} />
          )
        }
        onClick={toggleLock}
      />
    </Tooltip>
  );
};

export default LockMapButton;